import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Dashboard',
  tabs: {
    [tabs.general]: 'General',
    [tabs.overview]: 'Overview',
    [tabs.orders]: 'Orders by source',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Customers',
    [tabs.order_conversion]: 'Order conversion',
    [tabs.mobile_app]: 'Mobile app',
  },
  date_range: {
    this_month: 'This Month',
    last_month: 'Last Month',
    last_week: 'Last Week',
    this_week: 'This Week',
    this_year: 'This Year',
    last_year: 'Last Year',
    today: 'Today',
    yesterday: 'Yesterday',
    all: 'All',
  },
  buttons: {
    view_key_info: 'View key info',
  },
  empty_franchise: {
    description: 'This brand has no restaurant yet. Choose another brand in the menu to see its numbers.',
  },
};
